// Fictional, read-only data for the Purchasing & Inventory preference preview.
const copy = {
  en: {
    settings: {
      panelCopy: "Personalize your Purchasing & Inventory workspace with your preferred theme and language.",
      appearanceCopy: "Pilcore Day uses clean white surfaces and blue accents. Pilcore Night uses the deep Pilcore blue palette.",
      languageCopy: "Choose the language for navigation and translated Purchasing & Inventory screens.",
      previewSubheading: "Visual example with fictional purchase orders. No real orders are created.",
      previewActionNew: "New purchase order",
      note: "Theme and language changes apply immediately. No Save button is needed.",
    },
    sidebar: ["Overview", "Purchasing", "Inventory", "Reports", "Settings"],
    sidebarLabel: "Purchasing navigation preview",
    tabs: ["Purchase orders", "Purchase requisitions", "Goods receipts"],
    columns: ["Order", "Supplier", "Items", "Total", "Status"],
    items: ["24 bath towels", "12 packs of coffee", "6 desk lamps"],
    statuses: ["Received", "Approved", "Cancelled"],
    demoThemes: "Available Purchasing & Inventory themes. This demo keeps its current theme.",
  },
  es: {
    settings: {
      panelCopy: "Personaliza tu espacio de Compras e Inventario con el tema y el idioma que prefieras.",
      appearanceCopy: "Pilcore Day combina superficies blancas con acentos azules. Pilcore Night utiliza la paleta azul profunda de Pilcore.",
      languageCopy: "Elige el idioma de la navegación y las pantallas traducidas de Compras e Inventario.",
      previewSubheading: "Ejemplo visual con órdenes de compra ficticias. No se crean pedidos reales.",
      previewActionNew: "Nueva orden de compra",
      note: "El tema y el idioma cambian al instante. No necesitas pulsar Guardar.",
    },
    sidebar: ["Resumen", "Compras", "Inventario", "Informes", "Configuración"],
    sidebarLabel: "Ejemplo de navegación de compras",
    tabs: ["Órdenes de compra", "Solicitudes de compra", "Recepciones"],
    columns: ["Pedido", "Proveedor", "Artículos", "Total", "Estado"],
    items: ["24 toallas de baño", "12 paquetes de café", "6 lámparas de escritorio"],
    statuses: ["Recibido", "Aprobado", "Cancelado"],
    demoThemes: "Temas disponibles en Compras e Inventario. Esta demo mantiene su tema actual.",
  },
  ca: {
    settings: {
      panelCopy: "Personalitza el teu espai de Compres i Inventari amb el tema i l'idioma que prefereixis.",
      appearanceCopy: "Pilcore Day combina superfícies blanques amb accents blaus. Pilcore Night utilitza la paleta blava profunda de Pilcore.",
      languageCopy: "Tria l'idioma de la navegació i les pantalles traduïdes de Compres i Inventari.",
      previewSubheading: "Exemple visual amb comandes de compra fictícies. No es creen comandes reals.",
      previewActionNew: "Nova comanda de compra",
      note: "El tema i l'idioma canvien a l'instant. No cal prémer Desa.",
    },
    sidebar: ["Resum", "Compres", "Inventari", "Informes", "Configuració"],
    sidebarLabel: "Exemple de navegació de compres",
    tabs: ["Comandes de compra", "Sol·licituds de compra", "Recepcions"],
    columns: ["Comanda", "Proveïdor", "Articles", "Total", "Estat"],
    items: ["24 tovalloles de bany", "12 paquets de cafè", "6 llums d'escriptori"],
    statuses: ["Rebut", "Aprovat", "Cancel·lat"],
    demoThemes: "Temes disponibles a Compres i Inventari. Aquesta demo manté el seu tema actual.",
  },
};

export function getPurchasingThemePreview(languageId) {
  const text = copy[languageId] || copy.en;
  const locale = { en: "en-GB", es: "es-ES", ca: "ca-ES" }[languageId] || "en-GB";
  const money = new Intl.NumberFormat(locale, { style: "currency", currency: "EUR" });
  return {
    ...text,
    title: text.tabs[0],
    rows: [
      { id: "PO-1024", supplier: "Textiles Costa", amount: 288, tone: "confirmed" },
      { id: "PO-1025", supplier: "Café Norte", amount: 144, tone: "requested" },
      { id: "PO-1026", supplier: "Equipamiento Centro", amount: 210, tone: "cancelled" },
    ].map((row, index) => ({
      id: row.id,
      cells: [row.id, row.supplier, text.items[index], money.format(row.amount)],
      status: text.statuses[index],
      tone: row.tone,
    })),
  };
}
